<template>
	<div>
		<myheader :backFlag="true" headTitle="加入企业"></myheader>
		<div class="all_main all_main_padbottom">
			<div class="all_content_padding">
				<div class="all_tips_content_card">
					<div class="text12 textcolor999 font_weight_bold">请输入想要加入的企业</div>
					<div class="text14 textcolor666 margin_top_10">企业名称/社会统一信用代码</div>
					<div class="all_van_field" :class="{ isfocus: nameFocus }">
						<!-- 	<input class="my_input text14 textcolor333" v-model="enterpriseName" @focus="getFocus()"
							@blur="onblur()" /> -->
						<div class="display_inline_block" style="width:85%">
							<van-field v-model="enterpriseName" type="text" clearable @focus="getFocus()"
								@blur="onblur()" @keydown.enter="searchClick()" />
						</div>
						<button class="display_inline_block text14 textcolorwhite backgroundC_main all_line_height14 "
							style="width: 15%;border-radius: .2rem;background-color: #0277FC;"
							@click="searchClick()">搜索</button>
					</div>
					<div class="margin_top_5">
						<!-- style="position: absolute; top: 6.2rem;left: 0;right: 0;overflow-y: auto;" -->
						<div v-for="(item,index) in list" :key="index" style="position: relative;"
							@click="selectClick(item,index)">
							<div class="text12 textcolor333 font_weight_700 margin_top_3"
								style="padding-right: 1.5rem;">{{item.corpName}}</div>
							<div class="text12 textcolor999 margin_top_2">{{'企业编码：'+item.creditCode}}</div>
							<img v-if="index === selectIndex" class="join_selected" src="@/assets/images/selected.svg">
							<div class="horizontal_line margin_top_5"></div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="buttomCardShow" class="all_tips_bottom_card">
				<button class="all_button22 width_100 text16 bmain_active" @click="sumbit()">申请加入企业</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field
	} from 'vant';
	//Vue.use(Field);
	export default {
		components: {
			[Field.name]: Field,
		},
		data() {
			return {
				//企业id
				corpId: '',
				//企业名称
				corpName: '',
				nameFocus: false,
				//企业姓名
				enterpriseName: '',
				//企业列表
				list: [],
				//选中item index
				selectIndex: -1,
				//选中item
				selectItem: null,
				//屏幕高度
				height: 0,
				//按钮是否显示
				buttomCardShow: true,
			}
		},
		methods: {
			//提交申请加入企业
			sumbit() {
				if (this.selectIndex == -1) {
					this.$Toast('请选择要申请加入的企业！')
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/corp/m/api/applyJoinCorp?corpId=" + this.selectItem.corpId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							//this.$Toast('申请加入企业成功！')
							this.$router.push({
								path: '/joinenterprisestatus',
								query: {
									corpId: this.selectItem.corpId,
									corpName: this.selectItem.corpName,
									certifyStatusText: '审核中',
									applyStatus: '1',
									refresh: 1,
								}
							})
						} else {
							this.$Toast(res.message || '申请加入企业失败！')
						}
					});
			},
			//选择企业
			selectClick(item, index) {
				if (this.selectIndex != index) {
					this.selectIndex = index
					this.selectItem = item
					this.enterpriseName = item.corpName
				}
			},
			//搜索企业
			searchClick() {
				this.enterpriseName = this.enterpriseName.trim()
				if (!this.enterpriseName) {
					this.$Toast('请输入企业名称关键字！')
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/corp/m/api/queryCertifiedCorps?keyword=" + this.enterpriseName)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.list = res.data
						} else {
							this.$Toast(res.message || '查询企业失败！')
						}
					});
			},
			//获取焦点
			getFocus() {
				this.nameFocus = true
			},
			//失去焦点
			onblur() {
				this.nameFocus = false
			},
			//获取加入企业信息
			getJoinEnterpriseInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get('/corp/api/info/' + this.corpId, {}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.list.push(res.data)
						this.selectIndex = 0
						this.selectItem = this.list[0]
						this.enterpriseName = this.selectItem.corpName
					}
				})
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				//设置列表显示和数据选中
				if (this.corpId) {
					this.getJoinEnterpriseInfo()
				}
			},
			//屏幕变化时调用
			reResize() {
				if (this.height > 0 && document.body.clientHeight < this.height) {
					this.buttomCardShow = false
				} else {
					this.buttomCardShow = true
				}
			},
		},
		computed: {
			//初始化赋值
			setsize() {
				if (this.height == 0) {
					this.height = document.body.clientHeight
				}
			},
		},
		mounted() {
			window.addEventListener('resize', this.setsize);
			window.addEventListener('resize', this.reResize);
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.join_selected {
		position: absolute;
		width: 1rem;
		height: 1rem;
		top: .5rem;
		right: .5rem;
	}

	::v-deep .van-cell {
		padding: 10px .3rem;
	}
</style>